
export type ParseOptions = {
    lower?: boolean;
    upper?: boolean;
    unique?: boolean;
};

/**
 * Converts a CSV string of query parameters into a normalised array.
 * Example: 'wind,biogas,hydrogen' → ['wind','biogas','hydrogen']
 */
export function parseMulti(raw: string | null, opts: ParseOptions = {}): string[] {
    if (!raw) return [];
    let arr = raw.split(",").map((s) => s.trim()).filter(Boolean);

    if (opts.lower) arr = arr.map((s) => s.toLowerCase());
    if (opts.upper) arr = arr.map((s) => s.toUpperCase());
    if (opts.unique) arr = Array.from(new Set(arr));

    return arr;
}
